export default function (url, implementationCode, location = document.body) {
  const scriptTag = document.createElement('script');
  scriptTag.src = url;

  scriptTag.onload = implementationCode;
  scriptTag.onreadystatechange = implementationCode;

  location.appendChild(scriptTag);
}



// WEBPACK FOOTER //
// ./src/app/utils/loadExternal.js